import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_RESERVE_HISTORY_DETAIL_REQUEST,
  GET_RESERVE_HISTORY_DETAIL_SUCCESS,
  GET_RESERVE_HISTORY_DETAIL_FAILURE,
  GET_RESERVE_HISTORY_DETAIL_INITIAL,
} from '../../actions';

export type GetReserveHistoryDetailStateType = {
  isGetReserveHistoryDetailLoading: boolean;
  isGetReserveHistoryDetailLoaded: boolean;
  getReserveHistoryDetail: GetReserveHistoryDetailType;
};

type GetReserveHistoryDetailType = {
  result: number;
  data: ReserveDataType;
  visitor_data: VisitorDataType;
};

export type ReserveDataType = {
  data_id: string;
  schedule_id: number;
  companion: number | null;
  schedule_date: string | null;
  start_time: string | null;
  end_time: string | null;
  reservation_fixed_day: number | null;
  reservation_fixed_hours: number | null;
  reservation_fixed_minutes: number | null;
  cancel_abled_day: number | null;
  cancel_abled_hours: number | null;
  cancel_abled_minutes: number | null;
  alternate_label: string | null;
  contents_id: number | null;
  contents_annex_flag: number | null;
  contents_web_show_name: string | null;
  contents_classification: number | null;
  program_id: number | null;
  follow_people_upper: string | null;
  club_equipment_annex_flag: number | null;
  installed_seats_name: string | null;
  club_id: number | null;
  club_annex_flag: number | null;
  club_web_show_name: string | null;
  open_date: string | null;
  telephone_number: string | null;
  post_id: string | null;
  address: string | null;
  addr_buildname: string | null;
  annex_post_id: string | null;
  annex_address: string | null;
  annex_addr_buildname: string | null;
  layout_picture: string | null;
  reserve_time: string | null;
  reserve_time_label: string | null;
  reserve_available_time: string | null;
  reserve_available_time_label: string | null;
  cancel_available_time: string | null;
  cancel_available_time_label: string | null;
};

export type VisitorDataType = {
  visitor_id: string;
  visitor_name: string | null;
  visitor_sei: string | null;
  visitor_mei: string | null;
  mail_address: string | null;
  contact_telephone: string;
};

const initialState: GetReserveHistoryDetailStateType = {
  isGetReserveHistoryDetailLoading: false,
  isGetReserveHistoryDetailLoaded: false,
  getReserveHistoryDetail: {
    result: -1,
    data: {
      data_id: '',
      schedule_id: 0,
      companion: null,
      schedule_date: null,
      start_time: null,
      end_time: null,
      reservation_fixed_day: null,
      reservation_fixed_hours: null,
      reservation_fixed_minutes: null,
      cancel_abled_day: null,
      cancel_abled_hours: null,
      cancel_abled_minutes: null,
      alternate_label: null,
      contents_id: null,
      contents_annex_flag: null,
      contents_web_show_name: null,
      contents_classification: null,
      program_id: null,
      follow_people_upper: null,
      club_equipment_annex_flag: null,
      installed_seats_name: null,
      club_id: null,
      club_annex_flag: null,
      club_web_show_name: null,
      open_date: null,
      telephone_number: null,
      post_id: null,
      address: null,
      addr_buildname: null,
      annex_post_id: null,
      annex_address: null,
      annex_addr_buildname: null,
      layout_picture: null,
      reserve_time: null,
      reserve_time_label: null,
      reserve_available_time: null,
      reserve_available_time_label: null,
      cancel_available_time: null,
      cancel_available_time_label: null,
    },
    visitor_data: {
      visitor_id: '',
      visitor_name: '',
      visitor_sei: '',
      visitor_mei: '',
      mail_address: '',
      contact_telephone: '',
    },
  },
};

const getReserveHistoryDetailReducer = (state = initialState, action: AnyAction): GetReserveHistoryDetailStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_RESERVE_HISTORY_DETAIL_REQUEST:
        dataState.isGetReserveHistoryDetailLoading = true;
        dataState.isGetReserveHistoryDetailLoaded = false;
        dataState.getReserveHistoryDetail.result = initialState.getReserveHistoryDetail.result;
        dataState.getReserveHistoryDetail.data = initialState.getReserveHistoryDetail.data;
        dataState.getReserveHistoryDetail.visitor_data = initialState.getReserveHistoryDetail.visitor_data;
        break;
      case GET_RESERVE_HISTORY_DETAIL_SUCCESS:
        dataState.isGetReserveHistoryDetailLoading = false;
        dataState.isGetReserveHistoryDetailLoaded = true;
        dataState.getReserveHistoryDetail.result = action.res.data.result;
        dataState.getReserveHistoryDetail.data =
          action.res.data?.data_list?.[0] ?? initialState.getReserveHistoryDetail.data;
        dataState.getReserveHistoryDetail.visitor_data = action.res.data.visitor_data;
        break;
      case GET_RESERVE_HISTORY_DETAIL_FAILURE:
        dataState.isGetReserveHistoryDetailLoading = false;
        dataState.isGetReserveHistoryDetailLoaded = false;
        dataState.getReserveHistoryDetail.result = initialState.getReserveHistoryDetail.result;
        dataState.getReserveHistoryDetail.data = initialState.getReserveHistoryDetail.data;
        dataState.getReserveHistoryDetail.visitor_data = initialState.getReserveHistoryDetail.visitor_data;
        break;
      case GET_RESERVE_HISTORY_DETAIL_INITIAL:
        dataState.isGetReserveHistoryDetailLoading = false;
        dataState.isGetReserveHistoryDetailLoaded = false;
        dataState.getReserveHistoryDetail.result = initialState.getReserveHistoryDetail.result;
        dataState.getReserveHistoryDetail.data = initialState.getReserveHistoryDetail.data;
        dataState.getReserveHistoryDetail.visitor_data = initialState.getReserveHistoryDetail.visitor_data;
        break;
      default:
        break;
    }
  });
};

export default getReserveHistoryDetailReducer;
